import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import {
  RaglStockBlotterTable,
  type RaglStockBlotterTableViewContext,
} from '../../../../../../../../../../../../features/clearing-ledger/delta/ragl-stock-blotter-table';
import { getPageHead } from '../../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/stock-record/_stock-record/asset/$assetId/_asset/',
)({
  head: () => getPageHead('Stock Record Takeoff'),
  component: StockRecordTakeoff,
});

function StockRecordTakeoff() {
  const { assetId } = Route.useParams();
  const viewContext = useMemo(
    () =>
      ({
        kind: 'asset',
        assetId,
      }) as const satisfies RaglStockBlotterTableViewContext,
    [assetId],
  );

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglStockBlotterTable renderWhenEmpty="No Deltas" viewContext={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
